import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { DeliveryMethod } from '@/pages/LogisticsManage/LogisticsRoute/service';
import { DayTypeEnum } from '../type';

const model = {
  state: {
    businessDistrictList: [],
    businessDistrictId: null,
    meatTimeList: [], // 商圈餐段
    routeTabelParams: {
      pageSize: 10,
      page: 1,
    }, // 线路tabel参数
    routeParams: {
      cbdId: null,
      dispatchRouteId: null,
      transferStationId: null,
    }, // 筛选项
    modalVisible: false,
    currentMeatTimeId: null, // 当前餐段
    routeList: [], // 线路表格
    currentRoute: {}, // 当前选中线路
    selectRoute: {}, // 要调整到的线路
    routeCompanyData: [], // 线路企业
    currentCheckCompany: [], // 当前要调整的企业线路
    rebuildClickFlag: false, // 重置线路按钮是否可以点击
    routeListTotal: 0, // 线路总数
    allRouteList: [], // 总线路数组
    nonAddressNum: 0, // 无线路取餐点数量
    currentMeatTime: {},
    businessDistrict: {},
    deliveryMethod: DeliveryMethod.Transit.value,
    dayType: DayTypeEnum.WorkDay,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { basic, logisticsRoute }, getState }) => ({
    setDeliveryMethod(method) {
      logisticsRoute.setState({
        deliveryMethod: method,
      });
    },
    setDayType(dayType) {
      logisticsRoute.setState({
        dayType,
      });
    },
    // 获取全部生效商圈列表
    async getbusinessDistrictList(cbdId='', businessDistrictName='') {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/authority/queryCbdList', {
        params: {
          cbdStatus: 1, // 生效
        },
      });
      if (data) {
        const businessDistrictList = data.map((d) => ({
          value: d.businessDistrictId,
          label: d.businessDistrictName,
        }));
        logisticsRoute.setState({ businessDistrictList });
        // 默认选择第一个
        if (businessDistrictList.length > 0) {
          if(cbdId){
            logisticsRoute.setState({
              businessDistrictId: Number(cbdId),
              businessDistrict: {
                id: Number(cbdId),
                name: businessDistrictName,
              },
            });
          }else{
            logisticsRoute.setState({
              businessDistrictId: businessDistrictList[0].value,
              businessDistrict: {
                id: businessDistrictList[0].value,
                name: businessDistrictList[0].label,
              },
            });
          }
       
        }
      }
    },
    setBussinessFilter(param) {
      logisticsRoute.setState({
        routeParams: {
          ...param,
        },
      });
      logisticsRoute.getRouteList();
    },
    // 选择商圈
    setBusinessDistrict(id) {
      logisticsRoute.setState({ businessDistrictId: id });
    },
    setBusinessDistrictInfo(business) {
      logisticsRoute.setState({
        businessDistrictId: business.value,
        businessDistrict: {
          id: business.value,
          name: business.name,
        },
      });
    },
    // 重置筛选项
    onReset() {
      logisticsRoute.setState({
        routeParams: {
          cbdId: null,
          dispatchRouteId: null,
          transferStationId: null,
        },
      });
    },
    onRouteReset() {
      logisticsRoute.setState({
        routeTabelParams: {
          pageSize: 10,
          page: 1,
        },
      });
    },
    // 餐段
    async getMealTimeList() {
      const params = {
        businessDistrictId: getState().logisticsRoute.businessDistrictId,
      };
      const data = await fetch('/saasmerchant/fsarea/mealTime/queryBdMealTimes', {
        type: 'POST',
        params,
        useJson: true,
      });
      logisticsRoute.setState({
        meatTimeList: data,
      });
      if (data && data.length > 0) {
        logisticsRoute.setState({
          currentMeatTimeId: data[0].mealTimeId,
          currentMeatTime: {
            id: data[0].mealTimeId,
            name: data[0].mealTimeName,
          },
        });
      } else {
        logisticsRoute.setState({
          currentMeatTimeId: null,
          currentMeatTime: {},
        });
      }
    },
    // 获取线路列表
    async getRouteList(param = {}, rebuildClickFlag = false) {
      const {
        businessDistrictId,
        currentMeatTimeId,
        routeParams,
        routeTabelParams,
        deliveryMethod,
        dayType,
      } = getState().logisticsRoute;
      const params = filterNull({
        ...routeParams,
        ...routeTabelParams,
        cbdId: businessDistrictId,
        mealTimeId: currentMeatTimeId,
        deliveryMethod,
        dayType,
        ...param,
      });
      logisticsRoute.setState({
        routeListLoading: true,
      });
      const data = await fetch('/saasmerchant/fsarea/dispatchroute/list', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        const routeList = data.list || [];
        logisticsRoute.setState({
          nonAddressNum: data.nonAddressNum,
          routeList: [...routeList],
          routeListTotal: data.total,
        });
      }
      logisticsRoute.setState({
        routeListLoading: false,
      });
      if (rebuildClickFlag) {
        logisticsRoute.setState({
          rebuildClickFlag: false,
        });
      }
    },
    // setRouteShowType
    setRouteShowType(row) {
      const {routeList} = getState().logisticsRoute;
      routeList.forEach(route => {
        if(route?.dispatchRouteId === row?.dispatchRouteId){
          route.showType = !route.showType
        }
      })
      logisticsRoute.setState({
        routeList: [...routeList],
      });
    },
    // 导出线路
    async exportRouteList(param) {
      logisticsRoute.setState({
        routeParams: {
          ...param,
        },
      });
      const { businessDistrictId, currentMeatTimeId, deliveryMethod, dayType } =
        getState().logisticsRoute;
      const params = filterNull({
        ...param,
        cbdId: businessDistrictId,
        mealTimeId: currentMeatTimeId,
        deliveryMethod,
        dayType,
      });
      const data = await fetch('/saasmerchant/fsarea/dispatchroute/list/export', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    setCurrentRoute(route) {
      logisticsRoute.setState({
        currentRoute: route,
      });
      logisticsRoute.searchRoute(route.dispatchRouteId);
    },
    setCurrentMeatTimeId(meatId) {
      logisticsRoute.setState({
        currentMeatTimeId: meatId,
      });
    },
    setCurrentMeatTime(meal) {
      logisticsRoute.setState({
        currentMeatTimeId: meal.value,
        currentMeatTime: {
          id: meal.value,
          name: meal.children,
        },
      });
    },
    async searchRoute(dispatchRouteId, companyName = null, addressType) {
      const data = await fetch('/saasmerchant/fsarea/dispatchroute/search', {
        type: 'POST',
        params: filterNull({
          dispatchRouteId,
          companyName,
          addressType,
        }),
        useJson: true,
      });
      logisticsRoute.setState({
        routeCompanyData: data.map((company) => {
          return {
            title: company.companyName,
            value: company.companyId,
            key: company.companyId,
            children: company.addrs.map((addr) => {
              return {
                title: addr.address,
                value: addr.addrId,
                key: addr.addrId,
              };
            }),
          };
        }),
      });
    },
    setSelectRoute(route) {
      logisticsRoute.setState({
        selectRoute: route,
      });
    },
    handleCompanyChange(company) {
      logisticsRoute.setState({
        currentCheckCompany: company,
      });
    },
    resetRouteCompanyData() {
      logisticsRoute.setState({
        routeCompanyData: [],
        currentCheckCompany: [],
      });
    },
    setModalVisible(flag) {
      logisticsRoute.setState({
        modalVisible: flag,
      });
    },
    async modifyRoute(dispatchParams) {
      const { dispatchRouteName, dispatchRouteSimpleName, inRouteAddrIds } = dispatchParams;
      const { currentRoute, selectRoute, currentCheckCompany, deliveryMethod, businessDistrictId } =
        getState().logisticsRoute;

      if (!selectRoute) {
        message.error('请选择要调整到的线路');
        return;
      }
      const curRouteAddrIds = currentCheckCompany.map((route) => {
        return route.value;
      });
      const params = filterNull({
        dispatchRouteId: currentRoute.dispatchRouteId,
        dispatchRouteName,
        dispatchRouteSimpleName,
        targetRouteId: selectRoute.dispatchRouteId || null,
        targetRouteName: selectRoute.dispatchRouteId ? null : selectRoute.dispatchRouteName,
        inRouteAddrIds,
        outRouteAddrIds: curRouteAddrIds,
        deliveryMethod,
        cbdId: businessDistrictId,
      });
      const data = await fetch('/saasmerchant/fsarea/dispatchroute/modify', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('调整成功');
        logisticsRoute.setModalVisible(false);
        logisticsRoute.getRouteList();
      }
    },
    setFilter(params) {
      logisticsRoute.setState({
        routeTabelParams: { ...getState().logisticsRoute.routeTabelParams, ...params },
      });
    },
    // 翻页
    onNav(page) {
      logisticsRoute.setState({
        routeTabelParams: {
          page,
        },
      });
      logisticsRoute.getRouteList();
    },
    // 重置线路
    async rebuildRoute() {
      const { businessDistrictId, currentMeatTimeId, deliveryMethod, dayType } =
        getState().logisticsRoute;
      logisticsRoute.setState({
        rebuildClickFlag: true,
      });
      const data = await fetch('/saasmerchant/fsarea/dispatchroute/rebuild', {
        type: 'POST',
        params: {
          cbdId: businessDistrictId,
          mealTimeId: currentMeatTimeId,
          deliveryMethod,
          dayType,
        },
        useJson: true,
      });
      if (data) {
        message.success('重置成功，一分钟后生效');
        logisticsRoute.getRouteList({}, true);
      } else {
        logisticsRoute.setState({
          rebuildClickFlag: false,
        });
        message.error('重置失败');
      }
    },
  }),
};

export default model;
